import { SHOW_QUICK_DONATE_POP, HIDE_QUICK_DONATE_POP } from "redux/types";

import { Dispatch } from "redux";

export const setQuickDonatePopStateAction =
  (status: boolean) => (dispatch: Dispatch) => {
    dispatch({ type: SHOW_QUICK_DONATE_POP, payload: status });
    dispatch({ type: HIDE_QUICK_DONATE_POP, payload: status });
  };
